import { createApiClient } from "@pushup/shared";
import { env } from "./env";

/**
 * Include cookies on every request so the Better Auth session cookie is sent
 * with clip uploads.
 */
export const WITH_CREDENTIALS = { credentials: "include" } as const;

export const api = createApiClient({
  baseUrl: env.VITE_API_BASE_URL,
});

/**
 * Resolves an API-relative path (e.g. "/api/public-videos/:id/media") to an
 * absolute URL against the API root. The media streams live on the worker, not
 * on the site origin, so `<video>` src and share links must be pointed there.
 */
export function resolveApiUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  const base = env.VITE_API_BASE_URL.replace(/\/+$/, "");
  const root = base.endsWith("/api") ? base.slice(0, -4) : base;
  const origin =
    typeof window !== "undefined" && window.location?.origin
      ? window.location.origin
      : "http://localhost:5173";
  return `${root.startsWith("http") ? root : origin + root}${path.startsWith("/") ? "" : "/"}${path}`;
}
